import Layout from "@/layout";
import policy from "@/views/dashboard/policyService/index";
const cuttingEdgeRouter = {
  path: "/",
  component: Layout,
  redirect: "/policy",
  name: "intelligence",
  meta: { title: "“亲清”政策平台", icon: "bingchongqingbao" },
  children: [
    {
      path: "policy",
      name: "policyService",
      component: policy,
      redirect: "/policy/policySearch",
      meta: { title: "政策服务", icon: "" },
      children: [
        {
          path: "policySearch",
          component: () =>
            import("@/views/dashboard/policyService/policySearch/index"),
          name: "policySearch",
          meta: { title: "政策检索", activeMenu: "/policy", group: "policy" }
        },
        {
          path: "policyInfo",
          component: () =>
            import("@/views/dashboard/policyService/policyInfo/index"),
          name: "policyInfo",
          meta: { title: "政策详情", activeMenu: "/policy" }
        },
        {
          path: "policyMatch",
          component: () =>
            import("@/views/dashboard/policyService/policyMatch/index"),
          name: "policyMatch",
          meta: { title: "政策匹配", activeMenu: "/policy", group: "policy" }
        },
        {
          path: "policySubscribe",
          name: "policySubscribe",
          component: () =>
            import("@/views/dashboard/policyService/myPolicy/policySubscribe"),
          meta: { title: "政策订阅", activeMenu: "/policy", group: "policy" }
        },
        {
          path: "policyPush",
          name: "policyPush",
          component: () =>
            import("@/views/dashboard/policyService/myPolicy/policyPush"),
          meta: { title: "政策推荐", activeMenu: "/policy", group: "policy" }
        }
      ]
    }
  ]
};
export default cuttingEdgeRouter;
